
import history from '../../../history';
import { postInvitedAuthRep, getArInviteExists } from './ar-invitation-api';
import { setAuthRepInvitation, setArInvitationExists } from './ar-invitation-action-creator';
import * as MsgBarActions from '../system-shared/message-bar-action-creator';
import { getNewAccessTokenFromForcedRefresh } from '../auth/auth-middleware';

export const inviteAuthRep = (contactId) => (dispatch) =>
  postInvitedAuthRep(contactId)
    .then((response) => {
      dispatch(setAuthRepInvitation(response.data));
    })
    .catch(
      () => {
        dispatch(MsgBarActions.showErrorMessage('failedSendingEmail'));
        history.push('/edit-contact');
      }
    );

export const checkIfArInvitationExists = (contactId) => (dispatch) =>
  getArInviteExists(contactId)
    .then((response) => {
      dispatch(setArInvitationExists(response.data));
    }
    );

export const getPinPdfUrl = (invitationId) => (dispatch) =>
  dispatch(getNewAccessTokenFromForcedRefresh())
    .then(
      (token) =>
        Promise.resolve('/api/invitations/{0}/pinpdf?token={1}'
          .replace('{0}', invitationId).replace('{1}', token))
    );
